import { Action } from "redux";
import { isType } from "typescript-fsa";

import { IText } from "../classes/text";
import { initialInternationalizedText } from "./initialState";

import * as types from "../actions/actionTypes";
import * as actions from "../actions/searchToolbarActions";

export default function textReducer(state: IText = initialInternationalizedText, action: Action): IText {

  if (isType(action, actions.loadCalendarSettingsSuccess)) {
    const newState: IText = {...state, ...action.payload.text };
    return newState;
  }

  return state;
};
